<template>
	<form class="login-form" @submit.prevent="login">
		<div class="form-group">
			<label for="username">Username</label>
			<input
				type="text"
				class="form-control"
				name="username"
				placeholder="Username"
				v-model="user.username"
				:class="{ 'is-invalid': isInvalid.username }"
			/>
		</div>
		<div class="form-group">
			<label for="username">Password</label>
			<input
				type="password"
				class="form-control"
				name="firstName"
				placeholder="Password"
				v-model="user.password"
				:class="{ 'is-invalid': isInvalid.password }"
			/>
		</div>
		<div v-if="errMsg" class="form-group">
			<p v-if="errMsg" class="text-danger">{{ errMsg }}</p>
		</div>
		<div class="form-group mt-4">
			<button class="btn btn-primary w-100" type="submit">
				<span
					v-if="loading"
					class="spinner-border spinner-border-sm mr-2"
					role="status"
					aria-hidden="true"
				></span>
				Login
			</button>
		</div>
		<div class="form-group">
			<router-link
				class="btn btn-secondary w-100"
				:to="{ path: '/console/reset/send' }"
			>
				Forgot password?
			</router-link>
		</div>
		<div class="form-group">
			Don't have an account? - 
			<span
				class="text-primary hyper-click-primary"
				@click="redirect('/console/register')"
			>
				Register here
			</span>
		</div>
		<!--
		<div class="form-group">
			<span
				class="text-primary hyper-click-primary"
				@click="redirect('/')"
			>
				Return to home page
			</span>
		</div>
		-->
	</form>
</template>

<script>
import ConsoleService from '../../services/console';

export default {
	name: 'LoginForm',
	components: {
	},
	data() {
		return {
			user: {
				username: '',
				password: '',
			},
			isInvalid: {
				username: false,
				password: false,
			},
			loading: false,
			errMsg: '',
		};
	},
	methods: {
		redirect(path) {
			this.$router.push({ path });
		},
		login() {
			this.loading = true;
			ConsoleService.instance()
				.customLogin(this.user.username, this.user.password)
				.catch((err) => {
					this.loading = false;
					this.errMsg = err.message;
				});
		},
	},

	mounted() {
		if (this.$route.query.token && this.$route.query.token.length > 0) {
			this.ssoLogin(this.$route.query.token);
		}
	}

};
</script>

<style scoped>
.login-form {
	width: 100%;
	margin: auto;
}
.small {
	font-size: 1.4rem;
}
.f-size {
	font-size: 1.4rem;
}
.custom-control-input:hover,
.custom-control-label:hover {
	cursor: pointer;
}
</style>
